import React from "react";
import "./style.scss";

export const RingLoader = ({ className }) => {
  return (
    <div className={`ring_loader_container ${className || ""}`}>
      <span className="ring_loader"></span>
    </div>
  );
};
